import { useState } from "react";

export type ExistingFileController = ReturnType<typeof useExistingFileController>;

export function useExistingFileController() {
	/** State */
	const [pendingFileIds, setPendingFileIds] = useState<string[]>([]);

	/** Functions */
	function handleOnAddPendingFileIds(fileIds: string[]) {
		setPendingFileIds((ids) => [...new Set([...ids, ...fileIds])]);
	}

	function handleOnRemovePendingFileId(fileId: string) {
		setPendingFileIds((ids) => ids.filter((id) => id !== fileId));
	}

	function handleOnReset() {
		setPendingFileIds([]);
	}

	/** Return */
	return {
		pendingFileIds,
		handleOnAddPendingFileIds,
		handleOnRemovePendingFileId,
		handleOnReset,
	};
}
